class ColorReveal extends HTMLElement {
  connectedCallback() {
    this.mode = this.getAttribute('data-mode') || 'scroll';
    this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (this.reduced) {
      this.style.setProperty('--reveal-progress', 1);
      return;
    }
    if (this.mode === 'hover') this.#initHover();
    if (this.mode === 'scroll' && !CSS.supports('animation-timeline: view()')) this.#initScrollFallback();
  }

  #initHover() {
    const onMove = (e) => {
      const r = this.getBoundingClientRect();
      const x = (e.clientX - r.left) / r.width;
      this.style.setProperty('--reveal-progress', Math.max(0, Math.min(1, x)));
    };
    const onLeave = () => this.style.setProperty('--reveal-progress', 0);
    this.addEventListener('pointermove', onMove);
    this.addEventListener('pointerleave', onLeave);
    if (window.matchMedia('(pointer: coarse)').matches) {
      let dir = 1, p = 0;
      const tick = () => {
        p += 0.004 * dir;
        if (p >= 1) { p = 1; dir = -1; }
        if (p <= 0) { p = 0; dir = 1; }
        this.style.setProperty('--reveal-progress', p);
        this._raf = requestAnimationFrame(tick);
      };
      tick();
      this.addEventListener('touchstart', () => cancelAnimationFrame(this._raf), { passive: true });
    }
  }

  #initScrollFallback() {
    let ticking = false;
    const update = () => {
      ticking = false;
      const r = this.getBoundingClientRect();
      const vh = window.innerHeight;
      const start = vh * 0.85;
      const end = vh * 0.45;
      const range = start - end;
      const p = Math.max(0, Math.min(1, (start - r.top) / range));
      this.style.setProperty('--reveal-progress', p);
    };
    const onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
    window.addEventListener('scroll', onScroll, { passive: true });
    update();
  }
}
customElements.define('color-reveal', ColorReveal);
